import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { MenuOption, NavigationMenu } from '../navigation-menu/NavigationMenu';
import Footer from './Footer';
import { ThemeTokens } from '../../utilities/theme';

const LAYOUT_COLORS = {
  cardShadow: '#8e918f',
  accentGold: 'rgba(251, 197, 90, 0.77)',
  accentTeal: 'rgba(125, 210, 211, 0.77)',
  gradientNavy: 'rgb(46, 51, 78)',
  gradientBlue: 'rgb(45, 59, 89)',
  transparentStop: 'rgba(255, 255, 255, 0.0088410364)',
};

export interface LayoutProps {
  children: React.ReactNode;
  menuOptions?: MenuOption[];
  title?: string;
}

export function Layout({ children, menuOptions, title = 'COI' }: LayoutProps) {
  return (
    <div>
      <Box
        sx={{
          mx: '90px',
          boxShadow: `0 4px 8px ${LAYOUT_COLORS.cardShadow}`,
        }}
      >
        <Box
          sx={{
            backgroundColor: ThemeTokens.colors.primary.main,
            py: 3,
            px: 2,
            mt: 'auto',
          }}
        />
        {menuOptions && <NavigationMenu menuOptions={menuOptions} />}
        <Box
          sx={{
            height: '144px',
            padding: ' 30px 0 38px 42px',
            background: `linear-gradient(176deg,
              ${LAYOUT_COLORS.accentGold} 8%,${LAYOUT_COLORS.transparentStop} 8.5%),
              linear-gradient(5deg,
              ${LAYOUT_COLORS.accentTeal} 12%,${LAYOUT_COLORS.transparentStop} 12.5%),
              linear-gradient(71deg, ${LAYOUT_COLORS.gradientNavy} 39%, ${LAYOUT_COLORS.transparentStop} 39.1%), 
              linear-gradient(90deg, ${LAYOUT_COLORS.transparentStop} 0%, ${LAYOUT_COLORS.gradientBlue} 0%)`,
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontWeight: '400',
              fontSize: '40px',
              margin: ' 0 40px',
              color: 'white',
            }}
          >
            {title}
          </Typography>
        </Box>
        <Container
          sx={{
            minHeight: '55vh',
          }}
          maxWidth="xl"
        >
          {children}
        </Container>
        <Footer />
      </Box>
    </div>
  );
}
